import { render, staticRenderFns } from "./QuickPoint.vue?vue&type=template&id=10de6fe9&scoped=true&"
import script from "./QuickPoint.vue?vue&type=script&lang=js&"
export * from "./QuickPoint.vue?vue&type=script&lang=js&"
import style0 from "./QuickPoint.vue?vue&type=style&index=0&id=10de6fe9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10de6fe9",
  null
  
)

export default component.exports